import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {SelectFilterComponent} from '../../../../components/common/select-filter/select-filter.component';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {SelectFilterElement} from '../../../../components/common/select-filter/select-filter.model';
import {PaymentTypesUtils} from '../../../../shared/utils/payment-types.utils';
import {ValueAndLabelModel} from '../../../common/model/valueAndLabel.model';
import {AccountingAccountModel} from '../../account/api/entity/accountingAccount.model';
import {MovementType} from '../../movement/api/entity/accountingMovement.model';
import {MultipleSelectFilterComponent} from '../../../core/component/multiple-select-filter/multiple-select-filter.component';

@Component({
    selector: 'app-payment-type-select-filter',
    templateUrl: './payment-type-select-filter.component.html',
})
export class PaymentTypeSelectFilterComponent implements OnInit, OnChanges {

    loading: boolean;

    @ViewChild('selectFilter') selectFilterComponent: SelectFilterComponent<number, AccountingAccountModel>;
    @ViewChild('multipleSelectFilter') multipleSelectFilterComponent: MultipleSelectFilterComponent<number, AccountingAccountModel>;

    @Input() autoSelectFirstValue = true;
    @Input() single = true;
    @Input() movementType: MovementType;
    @Input() paymentTypeValueToIgnore: string;

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() noValueLabel: 'Aucun type de paiement';


    @Output() _onSingleSelectionChange = new EventEmitter<ValueAndLabelModel>();
    @Output() _onMultipleSelectionChange = new EventEmitter<ValueAndLabelModel[]>();


    elements: BehaviorSubject<SelectFilterElement<string, ValueAndLabelModel>[]> =
        new BehaviorSubject<SelectFilterElement<string, ValueAndLabelModel>[]>([]);

    constructor() {
    }

    ngOnInit() {
        this.refresh();
    }

    ngOnChanges(changes: SimpleChanges): void {
        const movementTypeChange = changes['movementType'];
        if (movementTypeChange && !movementTypeChange.isFirstChange()) {
            this.refresh();
        }

    }


    refresh() {
        const paymentTypes: ValueAndLabelModel[] = PaymentTypesUtils
            .getPaymentTypesForMovement(this.movementType,undefined, undefined);

        this.elements.next(paymentTypes
            .filter(value => !this.paymentTypeValueToIgnore || value.value !== this.paymentTypeValueToIgnore)
            .map(value => new SelectFilterElement(value.value, value.value, value)));
        const formControl = this.parentFormGroup.get(this.parentFormControlName);
        if (formControl && !formControl?.value && this.autoSelectFirstValue) {
            if (paymentTypes.findIndex(value => value.value === 'CASH') > -1) {
             formControl.setValue('CASH');
            } else if (paymentTypes.findIndex(value => value.value === 'CARD') > -1) {
                formControl.setValue('CARD');
            }
        }
    }

    filter = (criteria: string, entity: ValueAndLabelModel) => {
        return (entity.label).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
    }

    selectionChanged(value: SelectFilterElement<number, ValueAndLabelModel>) {
        if (value) {
            this._onSingleSelectionChange.emit(value.element);
        }
    }

    multipleSelectionChanged(values: ValueAndLabelModel[]) {
        this._onMultipleSelectionChange.emit(values);
    }

    public getSelectedElement(): AccountingAccountModel {
        return this.selectFilterComponent?.getSelectedElement();
    }

    public getSelectedElements(): AccountingAccountModel[] {
        return this.multipleSelectFilterComponent?.getSelectedElements();
    }

}
